import React, { FC } from 'react';

import clsx from 'clsx';

import projectConfig from '~/projects/config';

import styles from './styles.modules.scss';

const LogoIcon = projectConfig.getLogo();

type Props = {
  className?: string;
};

const Logo: FC<Props> = ({ className }) => {
  return (
    <a href="/" className={clsx(styles.logo, className)}>
      <LogoIcon />
    </a>
  );
};

export default Logo;
